/**
 * EyeCaptain for Chrome needs an account. Someone who opens it signed out
 * lands on /extension/connect, where they create a free account or sign in. We
 * remember which extension sent them, so that after signing up (email check
 * and onboarding included) or signing in they come back to the connect page
 * and the extension is linked on its own (auto=1).
 *
 * localStorage, because the email confirmation link can open in a new tab.
 * Necessary for the sign-up the visitor asked for; listed in cookieLibrary.ts.
 * Expires after two hours and is removed as soon as it is used.
 */
export const EXTENSION_RETURN_KEY = "ec_extension_return";
const TTL_MS = 2 * 3600_000;

export function rememberExtensionReturn(extId: string | null): void {
  if (!extId || !/^[a-p]{32}$/.test(extId)) return;
  try {
    localStorage.setItem(EXTENSION_RETURN_KEY, JSON.stringify({ ext: extId, at: Date.now() }));
  } catch {
    /* storage blocked: they can press Connect in the extension again */
  }
}

/** The connect page to return to, once; null when nothing is waiting. */
export function takeExtensionReturn(): string | null {
  try {
    const raw = localStorage.getItem(EXTENSION_RETURN_KEY);
    if (!raw) return null;
    localStorage.removeItem(EXTENSION_RETURN_KEY);
    const v = JSON.parse(raw) as { ext?: unknown; at?: unknown };
    if (typeof v.ext !== "string" || !/^[a-p]{32}$/.test(v.ext)) return null;
    if (typeof v.at !== "number" || Date.now() - v.at > TTL_MS) return null;
    return `/extension/connect?ext=${v.ext}&auto=1`;
  } catch {
    return null;
  }
}
